import { Flex, SkeletonText, Spacing } from '@billy/design-system'
import { ReactElement } from 'react'

import * as Styled from './styles'

export const FolderTreeSkeleton = (): ReactElement => (
  <Styled.FolderTreeWrapper>
    <Flex flexDirection="column" gap={Spacing.S8}>
      <SkeletonText width={160} />
      <SkeletonText width={200} />
      <SkeletonText width={220} />
      <SkeletonText width={180} />
      <SkeletonText width={200} />
    </Flex>
  </Styled.FolderTreeWrapper>
)
